<template>
	<!-- 介绍 -->
	<div class="editor-box">
		<div class="info">
			<div class="title van-multi-ellipsis--l3">{{ courseInfo.name }}</div>
			<div class="study-time">
				<span>共{{ courseInfo.contentNum }}个内容</span>
				<span class="mark"></span>
				<span>{{ courseInfo.studyNum }}人在学</span>
			</div>
			<div class="price">
				<p v-if="courseInfo.price > 0">
					<span class="price-num">{{ courseInfo.price }}</span> 巢币
				</p>
				<p v-else>
					<span class="price-num">免费</span>
				</p>
			</div>
		</div>
		<!-- 课程内容 -->
		<div class="course-content">
			<div class="content-title">
				<div class="big-title">课程选集</div>
				<div class="all" @click="changeTabs">
					<span>全部{{ courseInfo.contentNum }}节</span>
					<van-icon name="arrow" color="#999999" size="9px" />
				</div>
			</div>
			<div class="scroll-wrapper" ref="scrollRef">
				<div class="scroll-content">
					<div class="scroll-item" v-for="(item,index) in courseInfo.contentList" :key="item.id" :class="{'scroll-active':currentIdx === index}" @click="changeCurrent(index)">
						<div class="item-type">{{ typeArr[item.type] }}</div>
						<div class="item-title van-multi-ellipsis--l2">{{ item.name }}</div>
						<div class="mark" v-if="item.trySet === 1 || item.trySet === 2">
							试看
						</div>
						<WxOpenTag v-if="trainId" :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseInfo.id + '&trainId=' + trainId" />
						<WxOpenTag v-else :extinfo="'CFClass/detail?hideNativeNav=1&courseId='+ courseInfo.id" />
					</div>
				</div>
			</div>
		</div>
		<!-- 课程介绍 -->
		<div class="editor-info">
			<div class="editor-title">课程介绍</div>
			<div class="scroll-wrapper editor-wrapper" ref="editorScrollRef" :class="{'no-editor':courseInfo.lecturerList && courseInfo.lecturerList.length === 0}">
				<div class="scroll-content">
					<div class="editor-item" v-for="item in courseInfo.lecturerList" :key="item.id" @click="goToExpert(item.id)">
						<van-image lazy-load v-if="item.photoUrl" :src="item.photoUrl" round/>
						<van-image lazy-load v-else :src="ExpertHead" round/>
						<span class="van-ellipsis">{{ item.name }}</span>
					</div>
				</div>
			</div>
			<WangEditor v-if="courseInfo.introduce" :introduce="courseInfo.introduce"></WangEditor>
			<div class="no-data" v-else>
				<img :src="NoData" alt="">
				<span>暂无内容～</span>
			</div>
		</div>
		<!-- 知识点 -->
		<div class="knowledge" v-if="courseInfo.knowledgeList && courseInfo.knowledgeList.length > 0">
			<div class="knowledge-title">相关知识点</div>
			<div class="knowledge-list">
				<div class="knowledge-item" v-for="item in courseInfo.knowledgeList" :key="item.id" @click="goToKnow(item.id)">
					<div class="item-content van-ellipsis">{{ item.knowledgeName }}</div>
					<van-icon name="arrow" color="#F7443F" size="9px" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import WangEditor from "@/components/WangEditor.vue";
import BScroll from "better-scroll"
import NoData from "@/assets/image/learning/no_data.png";
import WxOpenTag from "@/components/WxOpenTag.vue"; // 链接
import ExpertHead from "@/assets/image/learning/expert_head.png";
export default {
	components: { WxOpenTag, WangEditor },
	props: {
		// 课程目录
		courseInfo: {
			type: Object,
			default: () => {
			},
		},
		trainId: {
			default: "",
		},
	},
	data() {
		return {
			NoData: NoData,
			bScroll:null,
			typeArr:['视频','文档','图片','音频','考试',"图文课","链接"],
			lecturerList:[], // 讲师列表
			currentIdx:0,
			ExpertHead: ExpertHead,
		};
	},
	mounted() {
		this.scrollInit();
	},
	methods: {
		// 滚动
		scrollInit() {
			this.bScroll = new BScroll(this.$refs.scrollRef, {
				scrollX: true,
				probeType: 3, // listening scroll event
				click:true,
			})
			this.editorScroll = new BScroll(this.$refs.editorScrollRef, {
				scrollX: true,
				probeType: 3, // listening scroll event
				click: true,
			})
		},
		// 切换选集
		changeCurrent(index){
			this.currentIdx = index;
		},
		// 切换tab
		changeTabs() {
			this.$emit('changeTabs', 1)
		},
		// 跳转到专家
		goToExpert(id) {
			this.$router.push({
				path: "/expertDetails",
				query: {
					id,
				},
			});
		},
		// 跳转到知识点
		goToKnow(id) {
			this.$router.push({
				path: "/knowledgePointsDetails",
				query: {
					id
				},
			});
		},
	},
}
</script>
<style scoped lang="css">
.editor-box {
	background-color: #F7F8F8;
}
.info{
	padding: 15px;
	background: #FFFFFF;
	margin-bottom: 8px;
}
.info .title{
	font-weight: 600;
	font-size: 17px;
	color: #1D2023;
	line-height: 23px;
}
.info .study-time{
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #777777;
	margin: 8px 0 10px;
}
.study-time .mark{
	width: 1px;
	height: 12px;
	background: #D8D8D8;
	margin: 0 8px;
}
.info .price{
	color: #E6001F;
	font-size: 12px;
}
.info .price-num{
	font-weight: 600;
	font-size: 17px;
}
.course-content{
	padding: 15px;
	margin: 8px 0;
	background-color: #fff;
}
.content-title{
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
}
.content-title .big-title{
	font-weight: 600;
	font-size: 18px;
	color: #1D2023;
}
.content-title .all{
	display: flex;
	align-items: center;

}
.all span{
	font-size: 12px;
	color: #777777;
}
.scroll-wrapper{
	position:relative;
	white-space: nowrap;
	overflow: hidden;
}
.scroll-content{
	display:inline-flex;
}
.scroll-content .scroll-item{
	position: relative;
	display: flex;
	flex-direction: column;
	width: 124px;
	height: 67px;
	background: #F7F9FA;
	border-radius: 4px;
	margin-right: 10px;
	padding: 8px;
	border: 1px solid transparent;
}
.scroll-item .item-type{
	font-weight: 500;
	font-size: 10px;
	color: #999999;
	margin-bottom: 2px;
}
.scroll-item .item-title{
	white-space: pre-wrap;
	font-weight: 600;
	font-size: 13px;
	color: #333333;
}
.scroll-item .mark{
	position: absolute;
	right: 0;
	top: 0;
	width: 31px;
	height: 16px;
	line-height: 16px;
	text-align: center;
	background: #FFDBDA;
	border-radius: 0 4px 0 4px;
	font-weight: 400;
	font-size: 10px;
	color: #F53F3F;
}
.scroll-content .scroll-active{
	background: #FFF6F6;
	border: 1px solid #E6001F;
}
.editor-wrapper{
	margin-bottom: 15px;
}
.no-editor{
	display: none;
}
.scroll-content .editor-item{
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 90px;
	height: 104px;
	background: #F7F9FA;
	border-radius: 4px;
	margin-right: 10px;
	padding: 10px;
	font-weight: 600;
	font-size: 14px;
	color: #333333;
}
.editor-item .van-image{
	width: 50px;
	height: 50px;
	border-radius: 50%;
	margin-bottom: 10px;
}
.editor-item span{
	width: 100%;
	text-align: center;
}
.editor-info{
	padding: 15px;
	margin: 8px 0;
	background-color: #fff;
}
.editor-info .editor-title{
	font-weight: 600;
	font-size: 18px;
	color: #1D2023;
	margin-bottom: 10px;
}
.knowledge{
	padding: 15px 15px 15px 7px;
	background-color: #fff;
}
.knowledge .knowledge-title{
	padding-left: 8px;
	font-weight: 600;
	font-size: 18px;
	color: #1D2023;
	margin-bottom: 12px;
}
.knowledge .knowledge-list {
	display: flex;
	flex-wrap: wrap;
}
.knowledge .knowledge-item{
	display: flex;
	align-items: center;
	justify-content: center;
	background: #FFF6F6;
	border-radius: 24px;
	border: 1px solid #F7443F;
	padding: 15px;
	margin: 10px 0 0 8px;
	min-width: 108px;
	max-width:150px;
}
.knowledge-item .item-content{
	font-weight: 400;
	font-size: 13px;
	color: #F7443F;
	max-width: 114px;
	margin-right: 2px;
}
.no-data{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 10px 0;
	font-weight: 400;
	font-size: 13px;
	color: #C0C4CC;
}
.no-data img{
	width: 113px;
	height: 113px;
	margin-bottom: 5px;
}
</style>